module.exports = __webpack_public_path__ + "img/calenders.27e19e3d.svg";